import {
  OnPackageStockFetched,
  OnPackageStockFetchError,
  OnPickersBindingsStockFetched,
  OnPickersBindingsStockFetchError,
  OnProductStockFetched,
  OnProductStockFetchError,
  OnSaleStockFetched,
  OnSaleStockFetchError
} from './stock.types'

export const SALE_STOCK_FETCHED = 'SALE_STOCK_FETCHED'
export const FETCH_SALE_STOCK_ERROR = 'FETCH_SALE_STOCK_ERROR'
export const PRODUCT_STOCK_FETCHED = 'PRODUCT_STOCK_FETCHED'
export const FETCH_PRODUCT_STOCK_ERROR = 'FETCH_PRODUCT_STOCK_ERROR'
export const PACKAGE_STOCK_FETCHED = 'PACKAGE_STOCK_FETCHED'
export const FETCH_PACKAGE_STOCK_ERROR = 'FETCH_PACKAGE_STOCK_ERROR'
export const PICKERS_BINDINGS_STOCK_FETCHED = 'PICKERS_BINDINGS_STOCK_FETCHED'
export const FETCH_PICKERS_BINDINGS_STOCK_ERROR = 'FETCH_PICKERS_BINDINGS_STOCK_ERROR'

export const onSaleStockFetched: OnSaleStockFetched = (response, key) => ({
  payload: { key, response },
  type: SALE_STOCK_FETCHED
})

export const onSaleStockFetchError: OnSaleStockFetchError = error => ({
  payload: { error },
  type: FETCH_SALE_STOCK_ERROR
})

export const onProductStockFetched: OnProductStockFetched = (response, key) => ({
  payload: { key, response },
  type: PRODUCT_STOCK_FETCHED
})

export const onProductStockFetchError: OnProductStockFetchError = error => ({
  payload: { error },
  type: FETCH_PRODUCT_STOCK_ERROR
})

export const onPackageStockFetchError: OnPackageStockFetchError = () => ({
  type: FETCH_PACKAGE_STOCK_ERROR
})

export const onPackageStockFetched: OnPackageStockFetched = (response, key) => ({
  payload: { key, response },
  type: PACKAGE_STOCK_FETCHED
})

export const onPickersBindingsStockFetched: OnPickersBindingsStockFetched = (packageKey, response) => ({
  payload: { packageKey, response },
  type: PICKERS_BINDINGS_STOCK_FETCHED
})

export const onPickersBindingsStockFetchError: OnPickersBindingsStockFetchError = () => ({
  type: FETCH_PICKERS_BINDINGS_STOCK_ERROR
})
